import { render, staticRenderFns } from "./NavLinkIcon.vue?vue&type=template&id=0aa07b9e&scoped=true&"
import script from "./NavLinkIcon.vue?vue&type=script&lang=js&"
export * from "./NavLinkIcon.vue?vue&type=script&lang=js&"
import style0 from "./NavLinkIcon.vue?vue&type=style&index=0&id=0aa07b9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa07b9e",
  null
  
)

export default component.exports